<template>
    <BModal @hidden="resetModal" size="lg" hide-footer ref="seriesModal" cancel-variant="outline-secondary" centered title="Realizar cobro"  no-close-on-backdrop>
      <ValidationObserver ref="form">
        <BForm @submit.prevent="">
          <BRow>
            <TextInputValidated vsName="Name" :vsModel.sync="serie.name" vsMd="6" vsRequired vsRules="required" />
            <TextInputValidated vsName="Invoice serie" :vsModel.sync="serie.invoice_serie" vsMd="6" vsRequired vsRules="required" />
            <TextInputValidated vsName="Corrective invoice serie" :vsModel.sync="serie.corrective_invoice_serie" vsMd="6" vsRequired vsRules="required" />
            <TextInputValidated vsName="Ticket serie" :vsModel.sync="serie.receipt_serie" vsMd="6" vsRequired vsRules="required" />
            <TextInputValidated vsName="Corrective ticket serie" :vsModel.sync="serie.corrective_receipt_serie" vsMd="6" vsRequired vsRules="required" />
            <TextInputValidated vsName="Expense serie" :vsModel.sync="serie.expense_serie" vsMd="6" vsRequired vsRules="required" />
          </BRow>

          <BRow class="mt-1">
            <CheckboxValidated vsMd="12"  vsName="Es evaluable" :vsModel.sync="serie.is_default"  vsLabel="Serie por defecto" />
            <BCol>
              <small><b>Es la que se usará en los automatismos. Se desmarcará la serie por defecto previa.</b></small>
            </BCol>
          </BRow>
          <BRow class="mt-1">
            <BCol>
              <BButton v-if="addModal"  variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" @click.prevent="onSubmit('add')"> {{ $t("Save") }} </BButton>
              <BButton v-else variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" @click.prevent="onSubmit('edit')"> {{ $t("Edit") }} </BButton>
            </BCol>
          </BRow>
        </BForm>
      </ValidationObserver>
    </BModal>
</template>

<script>
import {BForm,  BModal, BFormRadioGroup, BFormGroup,  BFormRadio, BRow, BCol, BInputGroup, BFormInput, BCard, BCardBody, BLink, BImg, BCardText, BButton, BPagination,BInputGroupAppend,BDropdownItem,BDropdown,BSidebar} from 'bootstrap-vue'
import { VueSelect } from 'vue-select'
import { inject, ref, watch } from '@vue/composition-api';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import { addSerie, getSerie, updateSerie } from '@/composables/serieService' 
import { ValidationObserver } from 'vee-validate'
import popups from "@/hooks/popups"

export default {
    components: { BForm, BModal, BCard, BFormGroup, BCardBody, BLink, BImg, BCardText, BButton, BFormRadioGroup, BFormRadio, BRow, BCol, BInputGroup, BInputGroupAppend, BFormInput, BPagination, BDropdownItem, BDropdown, BSidebar, VueSelect, TextInputValidated, DatepickerValidated, CheckboxValidated, NumberInputValidated, ValidationObserver },
    emits: ['refetch-data'] ,
    setup(props, {emit}) {
        const { successToast, errorToast } = popups()
        const form = ref(null)
        const addModal = inject('addModal')
        const group = inject('group')
        const serieId = inject('serieId')
        const seriesModal = inject('seriesModal')
        const serie = ref({
          name: '', 
          is_default: false, 
          invoice_serie: '', 
          corrective_invoice_serie: '', 
          receipt_serie: '', 
          corrective_receipt_serie: '', 
          expense_serie: ''
        })

        const onSubmit =  function (action) {
          serie.value.group_id=group.value.id
          form.value.validate().then(success => {
            if(success){
              action=="add" ? createEvaluation(serie.value) : editEvaluation(serie.value) 
            }
          })
        }
            
        const createEvaluation = async function(newEvaluation) {
          let response = await addSerie(newEvaluation)
          if (response.data.success) {
            successToast("Serie creada correctamente.")
            resetModal()
            emit("refetch-data")
          } else {
            if (response.data.code && response.data.code == "DEFAULT_SERIE_NEEDED" ) {
              errorToast("No puedes desmarcar la opción 'Por defecto', ya que no hay otra marcada.")
            } else {
              errorToast("Error creando serie")
            }

          }
        }

        const editEvaluation = async function (editedEvaluation) {
          let response = await updateSerie(editedEvaluation)
          if (response.data.success) {
            successToast("Serie actualizada correctamente.")
            resetModal()
            emit("refetch-data")
          } else {
            if (response.data.code && response.data.code == "DEFAULT_SERIE_NEEDED" ) {
              errorToast("No puedes desmarcar la opción 'Por defecto', ya que no hay otra marcada.")
            } else {
              errorToast("Error actualizando serie")
            }

          }
        }

        const fetchSerie = async function() {
            let response = await getSerie(serieId.value)
            serie.value = response.data.serie
            serie.value.is_default = serie.value.is_default==1 ? true : false
            addModal.value = null
        }

        watch(addModal, () => {
          if (addModal.value==false) {
            fetchSerie()
          }
        })

        const resetModal = () => {
          seriesModal.value.hide()
          serie.value = {
            name: '', 
            invoice_serie: '', 
            corrective_invoice_serie: '', 
            receipt_serie: '', 
            corrective_receipt_serie: '', 
            expense_serie: ''
          }
        }

        return {
            seriesModal,
            serie,
            form,
            onSubmit,
            addModal,
            resetModal,
        }
    }

}
    
</script>